import { loadView, withNestedView } from '@/router/routerHelpers';
import { FEATURES } from '@/access/features';
import { PERMISSIONS } from '@/access/permissions';

const loadAgentView = withNestedView('agents');

// Uses `permissions` (OR): the tiers are independent grants, so a manage- or edit-only user must still pass the route guard without view_agents.
const agentMeta = (extra = {}) => ({
  showNav: true,
  feature: FEATURES.CUSTOM_AGENTS,
  permissions: [
    PERMISSIONS.VIEW_AGENTS,
    PERMISSIONS.EDIT_AGENTS,
    PERMISSIONS.MANAGE_AGENTS,
  ],
  ...extra,
});

const agentsRoutes = [
  {
    path: '/agents',
    component: loadView('agents/AgentsGate'),
    children: [
      {
        path: '',
        name: 'agents',
        component: loadAgentView('Agents'),
        meta: agentMeta(),
      },
      {
        path: 'new',
        name: 'agentsNew',
        component: loadAgentView('AgentDetail'),
        props: { isNew: true },
        meta: agentMeta(),
      },
      {
        path: 'needs-assistance',
        name: 'agentsNeedsAssistance',
        component: loadAgentView('AgentNeedsAssistance'),
        meta: agentMeta(),
      },
      {
        path: ':id',
        component: loadAgentView('AgentDetail'),
        props: true,
        meta: agentMeta(),
        children: [
          { path: '', redirect: 'identity' },
          {
            path: 'identity',
            name: 'agentIdentity',
            component: loadAgentView('tabs/AgentInfoTab'),
            meta: agentMeta(),
          },
          {
            path: 'instructions',
            name: 'agentInstructions',
            component: loadAgentView('tabs/AgentInstructionsTab'),
            meta: agentMeta(),
          },
          {
            path: 'tools',
            name: 'agentTools',
            component: loadAgentView('tabs/AgentToolsTab'),
            meta: agentMeta(),
          },
          {
            path: 'contacts',
            name: 'agentContacts',
            component: loadAgentView('tabs/AgentContactsTab'),
            meta: agentMeta(),
          },
          {
            path: 'test',
            name: 'agentTest',
            component: loadAgentView('tabs/AgentTestTab'),
            meta: agentMeta(),
          },
          {
            path: 'logs',
            redirect: { name: 'agentIdentity' },
          },
          {
            path: 'versions',
            name: 'agentVersions',
            component: loadAgentView('tabs/AgentVersionsTab'),
            meta: agentMeta(),
          },
          {
            path: 'review-release',
            name: 'agentReviewRelease',
            component: loadAgentView('tabs/AgentReviewReleaseTab'),
            meta: agentMeta(),
          },
        ],
      },
    ],
  },
];

export default agentsRoutes;
